import { createRouter, createWebHistory } from 'vue-router'
import asyncRoutes from './asyncRoutes'
import constRoutes from './constRoutes'

const routes = [
  ...asyncRoutes,
  ...constRoutes
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
